import React, { useState } from 'react';
import LoginInput from '../components/inputs/LoginInput';
import { useNavigate, useLocation } from "react-router-dom";
import '../App.scss';
import { emailValidation } from '../functions/Validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export default function LoginForm(props: any) {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    props.setCurrentPage(0);
    props.setSidebarVisibility(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState<string | null>(null);
    const [passwordError, setPasswordError] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const login = async (e: React.FormEvent) => {
        setLoading(true);
        e.preventDefault();
        setError(null);

        let isValid = true;
        //Trigger email validation
        if (emailValidation(email)) {
            setEmailError(null);
        } else {
            setEmailError('Please enter a valid email');
            isValid = false;
        }
        //Trigger password validation
        if (password) {
            setPasswordError(null);
        } else {
            setPasswordError('Password is required');
            isValid = false;
        }

        if (isValid) {
            fetch(`${apiBaseUrl}Admin/Login?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`, {
                method: 'GET',
                headers: { 'Accept': 'application/json', },
            })
                .then((response) => {
                    if (!response.ok) {
                        setError(`Server error: ${response.statusText}`);
                        setLoading(false);
                        return
                    }
                    return response.json();
                })
                .then((result) => {
                    if (result.success) {
                        setError(null);
                        const parsedObject = JSON.parse(result.object)
                        const userData = {
                            email,
                            token: parsedObject.token,
                            tokenExpiry: Date.now() + parsedObject.expiresIn * 1000,
                            inactivityExpiry: Date.now() + 10 * 60 * 1000,//10 minutes
                            insuredPartyIds: parsedObject.insuredPartyIds
                        };
                        props.loginSuccess(JSON.stringify(userData))
                    } else {
                        setError('Login failed. Please check your credentials.');
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setError('An error occurred. Please try again later.');
                    setLoading(false);
                });
        }
        else {
            setLoading(false);
        }
    };

    const updateEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    };
    const updatePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value)
    };

    return (
        <div className="login-form-wrapper">
            <form className="login-form" onSubmit={login}>
                <p className="notification-title">Login</p>
                <LoginInput
                    label="Email"
                    type="email"
                    placeholder="Enter your email"
                    validate={(value: string) => (emailValidation(value) ? null : 'Please enter a valid email')}
                    onChange={updateEmail}
                    submitError={emailError}
                    page="login"
                    disabled={loading}
                />
                <br />
                <LoginInput
                    label="Password"
                    type="password"
                    placeholder="Enter your password"
                    validate={(value: string) => (value ? null : 'Password is required')}
                    onChange={updatePassword}
                    submitError={passwordError}
                    page="login"
                    disabled={loading}
                />
                <br />
                <div className="btn-container">
                    {loading && <button disabled className="btn primary loading" type="submit">Logging In <FontAwesomeIcon icon={faSpinner} spinPulse /></button> || 
                        <button className="btn primary" type="submit">Login</button>}
                    
                </div>
                {error && <p className="error-message">{error}</p>}
                <div className="formLinks">
                    <span onClick={() => navigate('/Register')}>Register</span>
                    <span onClick={() => navigate('/ForgotPassword')}>Forgot Password?</span>
                </div>
            </form>
        </div>
    );
};

